<template>
    <section 
    class="hero is-danger is-medium"
        v-bind:style="{
            'background': 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(' + image + ') center',
            'background-size': 'cover'
        }">
        <div class="hero-body">
            <div class="container has-text-centered">
                <p class="title has-text-white">
                    {{ title }}
                </p>
                <div class="columns">
                    <div class="column has-text-centered" >
                        <span :class="'mdi mdi-' + icon1 + ' has-text-white is-size-1'" />
                        <h1 class="subtitle">
                            {{ text1 }}
                        </h1>
                    </div>
                    <div class="column has-text-centered" >
                        <span :class="'mdi mdi-' + icon2 + ' has-text-white is-size-1'" />
                        <h1 class="subtitle">
                            {{ text2 }}
                        </h1>
                    </div>
                    <div class="column has-text-centered" >
                        <span :class="'mdi mdi-' + icon3 + ' has-text-white is-size-1'" />
                        <h1 class="subtitle">
                            {{ text3 }}
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ProductIntro',
    props: {
        title: String,
        image: String,
        icon1: String,
        text1: String,
        icon2: String,
        text2: String,
        icon3: String,
        text3: String
    }
}
</script>